export { default as chevronWhite } from './chevronWhite.png'
export { default as chevronBlack } from './chevronBlack.png'
export { default as river } from './river.jpg'
export { default as kyle } from './kyle.jpg'
export { default as turntable } from './turntable.jpg'



// WEBPACK FOOTER //
// ./src/layouts/images/index.js